module.exports = __webpack_public_path__ + "img/blackdiamond-1vFjnFO.svg";